import CategoryIcon from "../ui/icons/Category";
import PersonIcon from "../ui/icons/Person";
import ProductionQuantityLimitsIcon from "../ui/icons/ProductionQuantityLimits";
import BusinessIcon from "../ui/icons/Business";
import PaletteIcon from "../ui/icons/Palette";
import {
  ACTMGMT,
  BILLMGMT,
  COMBOFOODITEMGMT,
  COMBOMGMT,
  CUSTOMERRIDERAPP,
  CUSTOMERMGMT,
  CUSTOMUNITMGMT,
  CartDets,
  DashboardComponent,
  EMPMGMT,
  FOODITEMPRODUCTMGMT,
  INVSTOCKMGMT,
  OWNERDASHBOARD,
  RECPMGMT,
  REPGEN,
  ROLE_CREATE,
  ROLE_VIEW,
  SHOWITEMWISESALES,
  STOCKMGMT,
  SUPMGMT,
  CHATSUPPMGMT,
  CUSTOMIZEDCONFIG,
  KITCHENMGMT,
  VOICEMGMT,
  COUPONMANAGEMENT
} from "../../constants/constant";
import { AccountCircle } from "../ui/icons";
import AdUnitsIcon from '../ui/icons/AdUnits';
import ReceiptLongIcon from '../ui/icons/ReceiptLong';
import AccountBalanceIcon from '../ui/icons/AccountBalance';
import LocalOfferIcon from '../ui/icons/LocalOffer';
import AutoGraphIcon from '../ui/icons/AutoGraph';
import MopedIcon from '../ui/icons/Moped';
import AccountTreeIcon from '../ui/icons/AccountTree';
import FoodBankIcon from '../ui/icons/FoodBank';
import InventoryIcon from '../ui/icons/Inventory';
import ForumIcon from '../ui/icons/Forum';
import SettingsVoiceIcon from '../ui/icons/SettingsVoice';
import SoupKitchenIcon from '../ui/icons/SoupKitchen';
import PrinterIcon from '../ui/icons/Printer';

export const sideBarNavItems = [
  {
    title: "Owner Dashboard",
    index: DashboardComponent.REPORTMANAGEMENT,
    icon: <AutoGraphIcon />,
    cartTypes: [CartDets.All],
    feature: OWNERDASHBOARD,
    permission: { feature: OWNERDASHBOARD, action: ROLE_VIEW },
    path: "/dashboard/home",
  },
  {
    title: "Report Generation",
    index: DashboardComponent.REPORTGENERATION,
    icon: <ReceiptLongIcon />,
    cartTypes: [CartDets.All],
    permission: { feature: REPGEN, action: ROLE_VIEW },
    feature: REPGEN,
    path: "/dashboard/report-generation",
  },
  {
    title: "Item Sale Dashboard",
    index: DashboardComponent.ITEMSALEDASHBOARD,
    icon: <AccountTreeIcon />,
    cartTypes: [CartDets.Resto],
    permission: { feature: SHOWITEMWISESALES, action: ROLE_VIEW },
    feature: SHOWITEMWISESALES,
    path: "/dashboard/itemsaledashboard",
  },
  {
    title: "Maintain Employee",
    index: DashboardComponent.EMPLOYEE,
    icon: <AccountCircle />,
    cartTypes: [CartDets.All],
    permission: { feature: EMPMGMT, action: ROLE_VIEW },
    feature: EMPMGMT,
    path: "/dashboard/employee",
  },
  {
    title: "Maintain Category",
    index: DashboardComponent.CATEOGORY,
    icon: <CategoryIcon />,
    cartTypes: [CartDets.All],
    permission: { feature: [INVSTOCKMGMT, FOODITEMPRODUCTMGMT], action: ROLE_VIEW },
    feature: [INVSTOCKMGMT, FOODITEMPRODUCTMGMT],
    path: "/dashboard/cateogory",
  },
  {
    title: "Inventory Create",
    index: DashboardComponent.PRODUCTENTRY,
    icon: <InventoryIcon />,
    cartTypes: [CartDets.Pharma, CartDets.Kirana, CartDets.Watch, CartDets.Gold],
    permission: { feature: INVSTOCKMGMT, action: ROLE_VIEW },
    feature: [INVSTOCKMGMT],
    path: "/dashboard/showproduct",
  },
  {
    title: "Food Item/Product Management",
    index: DashboardComponent.PRODUCTENTRY,
    icon: <InventoryIcon />,
    cartTypes: [CartDets.Resto],
    permission: { feature: FOODITEMPRODUCTMGMT, action: ROLE_VIEW },
    feature: [FOODITEMPRODUCTMGMT],
    path: "/dashboard/itementry",
  },
  {
    title: "Coupon Management",
    index: -1,
    icon: <LocalOfferIcon />,
    cartTypes: [CartDets.All],
    feature: COUPONMANAGEMENT,
    path: "/dashboard/coupon",
  },
  {
    title: "Kitchen",
    index: -1,
    icon: <SoupKitchenIcon />,
    cartTypes: [CartDets.Resto],
    chefOnly: true,
    feature: KITCHENMGMT,
    path: "/dashboard/kitchen",
  },
  {
    title: "Supplier Information",
    index: DashboardComponent.SUPPLIER,
    icon: <BusinessIcon />,
    cartTypes: [CartDets.All],
    permission: { feature: SUPMGMT, action: ROLE_VIEW },
    feature: SUPMGMT,
    path: "/dashboard/supplier",
  },
  {
    title: "Live Stock Update",
    index: DashboardComponent.STOCKENTRY,
    icon: <ProductionQuantityLimitsIcon />,
    cartTypes: [CartDets.Pharma, CartDets.Kirana, CartDets.Watch],
    permission: { feature: STOCKMGMT, action: ROLE_VIEW },
    feature: STOCKMGMT,
    path: "/dashboard/stockentry",
  },
  //5 is Stock Entry
  {
    title: "Custom Unit",
    index: DashboardComponent.CUSTOMUNIT,
    icon: <AdUnitsIcon />,
    cartTypes: [CartDets.All],
    permission: { feature: CUSTOMUNITMGMT, action: ROLE_VIEW },
    feature: CUSTOMUNITMGMT,
    path: "/dashboard/customunit",
  },
  {
    title: "Billing Management",
    index: DashboardComponent.BILLDETAILS,
    icon: <ReceiptLongIcon />,
    cartTypes: [CartDets.Resto],
    permission: { feature: BILLMGMT, action: ROLE_CREATE },
    feature: BILLMGMT,
    path: "/dashboard/billhandler",
  },
  {
    title: "Billing Management",
    index: DashboardComponent.BILLCONNECTOR,
    icon: <ReceiptLongIcon />,
    cartTypes: [CartDets.Pharma, CartDets.Kirana],
    permission: { feature: BILLMGMT, action: ROLE_CREATE },
    feature: BILLMGMT,
    path: "/dashboard/billhandler",
  },
  // {
  //   title: "Service Charge",
  //   index: 8,
  //   icon: <ChargingStation />,
  //   cartTypes: [CartDets.All],
  //   permission: ADMINRIGHTS,
  // },
  {
    title: "Notification Settings",
    index: DashboardComponent.THEME,
    icon: <PaletteIcon />,
    cartTypes: [CartDets.Resto],
    path: "/dashboard/ecart",
  },
  {
    title: "Voice Settings",
    index: DashboardComponent.THEME,
    icon: <SettingsVoiceIcon />,
    cartTypes: [CartDets.All],
    feature: VOICEMGMT,
    path: "/dashboard/voice-settings",
  },
  {
    title: "Printer Configuration",
    index: DashboardComponent.PRINTERCONFIG,
    icon: <PrinterIcon />,
    cartTypes: [CartDets.All],
    feature: CUSTOMIZEDCONFIG,
    path: "/dashboard/printer-configuration",
  },
  {
    title: "Customer Details",
    index: DashboardComponent.CUSTOMER,
    icon: <PersonIcon />,
    cartTypes: [CartDets.All],
    permission: { feature: CUSTOMERMGMT, action: ROLE_VIEW },
    feature: CUSTOMERMGMT,
    path: "/dashboard/customer",
  },
  //11 is profile
  {
    title: "Balance Sheet",
    index: DashboardComponent.ACCOUNTING,
    icon: <AccountBalanceIcon />,
    cartTypes: [CartDets.All],
    permission: { feature: ACTMGMT, action: ROLE_VIEW },
    feature: ACTMGMT,
    path: "/dashboard/accounting",
  },
  {
    title: "Combo Offer",
    index: DashboardComponent.COMBOOFFER,
    icon: <LocalOfferIcon />,
    cartTypes: [CartDets.All],
    permission: { feature: [COMBOMGMT, COMBOFOODITEMGMT], action: ROLE_VIEW },
    feature: [COMBOMGMT, COMBOFOODITEMGMT],
    path: "/dashboard/comboentry",
  },
  {
    title: "Track Rider",
    index: DashboardComponent.TRACKRIDER,
    icon: <MopedIcon />,
    cartTypes: [CartDets.Resto],
    permission: { feature: CUSTOMERRIDERAPP, action: ROLE_VIEW },
    feature: CUSTOMERRIDERAPP,
    path: "/dashboard/trackrider",
  },
  {
    title: "Receipe Management",
    index: DashboardComponent.RECEIPEMGMT,
    icon: <FoodBankIcon />,
    cartTypes: [CartDets.Resto],
    permission: { feature: RECPMGMT, action: ROLE_VIEW },
    feature: RECPMGMT,
    path: "/dashboard/receipe",
  },
  {
    title: "Chat Support",
    index: DashboardComponent.CHATSUPPORT,
    icon: <ForumIcon />,
    cartTypes: [CartDets.All],
    permission: { feature: CHATSUPPMGMT, action: ROLE_VIEW },
    feature: CHATSUPPMGMT,
    path: "/dashboard/chat-admin",
  }
];
